// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1fdc2","file":"styles_file__2R8Ux"};